import request from './request'

// 侧边栏 权限
export const NavLeft = (pagenum,pagesize)=>request({
    url:`Auth/getdata`,
    params:{pagenum,pagesize},
    method:'post'
})
// 首页登录
export const Longin = (optname,optpassword,clienttype)=>request({
    url:'Userinfo/userlogin',
    method:'post',
    params:{
        optname,optpassword,clienttype
    }
})

export const homeData_index = ()=>request({
    url:'Gatewaydata/getdata_index_pc',
    params:{},
})

//客户
export const LonginKH = (optname,optpassword,clienttype,logintype,login_uuid)=>request({
    url:'Userinfo/userlogin',
    method:'post',
    params:{
        optname,optpassword,clienttype,logintype,login_uuid
    }
})

// s首页
export const adminIndex = (position)=>request({
    url:'Index/admin_index',
    params:{
        position
    },
    method:'post'
})
// 首页地图
export const AlistprovinceMap = ()=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        mapflag:1
    }
})
// 首页的折线图
export const homeGetUidIn = (gateway_uuid)=>request({
    url:'Gatewaydata/getdata',
    params:{
        gateway_uuid,
        // dateset:'1day',
        pagenum:1,
        pagesize:1
    },
})
// 获取报警信息
export const baojingDataList = ()=>request({
    url:'Gatewayinfo/getdata_state',
    params:{
        state:0
    },
    method:'post'
})
// 报警备注
export const baojingBeizu = (data)=>request({
    url:'Gatewayinfo/udpatedata_offlineremark',
    params:{
        gatewaylist:data
    },
    method:'post'
})
// 用户列表
export const userList = (pagenum,pagesize,dealer_uuid,customer_uuid)=>request({
    url:'UserInfo/getdata',
    params:{
        pagenum,
        pagesize,
        dealer_uuid,
        customer_uuid
    },
    method:'post'
})

// 获取用户默认打开接口

export const userIndexMode = (pagenum,
    pagesize,)=>request({
    url:'Userinfo/getdata_index',
    params:{
        pagenum,
        pagesize,
    },
    method:'post'
})

// 新增和修改 用户权限
export const updatedataOut = (data)=>request({
    url:'Userinfo/updatedata',
    params:data,
    method:'post'
})

// 经销商列表
export const Dealerinfo  = (countycode,pagenum,pagesize)=>request({
    url:'Dealerinfo/getdata',
    params:{
        countycode,
        pagenum,
        pagesize
    }
})
// 添加供应商信息
export const Updatedata =(data)=>request({
    url:'Dealerinfo/updatedata',
    params:data,
    method:'post'
})

// //修改经销商信息
// export const dealerDdi = (data)=>request({
//     url:'Dealerinfo/dealer_edit',
//     params:data,
//     method:'post'
// })

// 经销商删除 客户删除 区域  网关  网关通道
export const dealerDelete = (uuid,tablename)=>request({
    url:'Index/deleteinfo',
    params:{
        uuid,
        tablename
    },
    method:'post'
})

//经销商详情
export const DealerinfoDetile = (uuid)=>request({
    url:'Dealerinfo/dealerinfo',
    method:'post',
    params:{
        uuid
    }
})


/**-------------------经销商结束--------------------------------------------------------* */
// 客户信息列表
export const customerlist = (dealer_uuid,pagenum,pagesize)=>request({
    url:'Customerinfo/getdata',
    params:{
        dealer_uuid,
        pagenum,pagesize
    },
    method:'post'
})
//添加客户信息 和修改
export const customerAadd = (data)=>request({
    url:'Customerinfo/updatedata',
    params:data,
    method:'post'
})


//删除客户信息
// export const customerDelete = (uuid)=>request({
//     url:'Customerinfo/customer_delete',
//     params:{
//         uuid
//     },
//     method:'post'
// })


//客户详情
export const customerinfo = (uuid)=>request({
    url:'Customerinfo/customerinfo',
    params:{
        uuid  
    },
    method:'post'
})

// -----------------------------结束-------------------------------------

//区域列表
export const arealist = (customer_uuid,pagenum,pagesize)=>request({
    url:'Areainfo/getdata',
    params:{
        customer_uuid,
        pagenum,pagesize
    }
})


//区域列表
export const arealistFromg = (customer_uuid)=>request({
    url:'Areainfo/getdata',
    params:{
        customer_uuid,
    }
})
// 移动网关
export const yidongDataLisnt = (data)=>request({
    url:'Gatewayinfo/movedata',
    params:data,
    method:'post'
})
// 添加区域列表 修改
export const areaAdd = (data)=>request({
    url:'Areainfo/updatedata',
    params:data
})
// 查询网关是否上传数据
export const dataUpdataD = (uuid)=>request({
    url:'Gatewayinfo/gatewaydata_flag',
    params:{
        uuid
    },
    method:'post'
})

// 区域详情
export const areainfoDetile = (uuid)=>request({
    url:'Areainfo/areainfo',
    params:{
        uuid
    },
    method:'post'
})

//-----------------------------结束--------------------

// 网管列表
export const Alist = (area_uuid,pagenum,pagesize)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        area_uuid,pagenum,pagesize
    },
})
// 网关列表省
export const Alistprovince = (provincecode,pagenum,pagesize)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        provincecode,pagenum,pagesize
    },
})
// 网关列表 市city

export const Alistcity = (citycode,pagenum,pagesize)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        citycode,pagenum,pagesize
    },
})

// 网关区域 
export const Alistcounty = (countycode,pagenum,pagesize)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        countycode,pagenum,pagesize
    },
})

// 复制网关id
export const coplyEnd = (data)=>request({
    url:'Gatewayinfo/copydata',
    params:data,
    method:'post'
})

// 经销商 网关 treesList
export const AlisttreesList = (dealer_uuid,pagenum,pagesize)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        dealer_uuid,pagenum,pagesize
    },
})

// 客户网关 treesUid
export const AlisttreesUid = (customer_uuid,pagenum,pagesize)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        customer_uuid,pagenum,pagesize
    },
})


export const AlistInfo = (uuid)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        uuid,
    },
})
// 网管详细信息

export const  gatewayinfo = (uuid)=>request({
    url:'Gatewayinfo/gatewayinfo',
    params:{
        uuid
    },
    method:'post'
})

// 添加网关  修改网关
export const gatewayAadd  = (data)=>request({
    url:'Gatewayinfo/updatedata',
    params:data,
    method:'post'
})

//-------------------------结束------------------------------

// 网关通道信息列表
export const listwgtd = (gateway_uuid,pagenum,pagesize)=>request({
    url:'Channelinfo/getdata',
    params:{
        gateway_uuid,pagenum,pagesize
    },
    method:'post'
})

export const listwgtduUID = (property_uuid,pagenum,pagesize)=>request({
    url:'Channelinfo/getdata',
    params:{
        property_uuid,pagenum,pagesize
    },
    method:'post'
})
// 网管通道添加  修改网关  gateway_uuid
export const  channelAdd= (gateway_uuid,channel,flag,number,startaddress,property_uuid,deviceid)=>request({
    url:'Channelinfo/updatedata',
    params:{
        gateway_uuid,channel,flag,number,startaddress,property_uuid,deviceid
    },
    method:'post'
})


export const  channelAddEditWG = (channel)=>request({
    url:'Channelinfo/updatedata',
    params:channel,
    method:'post'
})
// 网管通道 修改
export const  channelAddEdit = (data)=>request({
    url:'Channelinfo/updatedata',
    params:data,
    method:'post'
})


// 传感单元列表

export const listCgDy = (pagenum,pagesize)=>request({
    url:'Sensingunitinfo/getdata',
    params:{pagenum,pagesize},
    method:'post'
})


// 查询
export const listCgDySearch = (search)=>request({
    url:'Sensingunitinfo/getdata',
    params:{search},
    method:'post'
})


// 添加传感单元列表 修改传感单元

export  const sensingunitAdd  = (data)=>request({
    url:'Sensingunitinfo/updatedata',
    params:data,
    method:'post'
})

// 修改传感单元

export const sensingunitEdit = (data)=>request({
    url:'Sensingunitinfo/sensingunit_edit',
    params:data,
    method:'post'
})

//删除传感单元

export const sensingunitDdelete = (uuid)=>request({
    url:'Sensingunitinfo/sensingunit_delete',
    params:{
        uuid
    },
    method:'post'
})

// 首页的折线图
export const homeGetUid = (gateway_uuid)=>request({
    url:'Gatewaydata/getdata',
    params:{
        gateway_uuid,
        dateset:'1day',
        pagenum:1,
        pagesize:1
    },
})

// 网管查询数据
export const getdata = (datainfo)=>request({
    url:'Gatewaydata/getdata',
    params:datainfo,
    method:'post'
})

// 召测数据

export const updataList = (datainfo)=>request({
    url:'Gatewaydata/getdata',
    params:datainfo,
    method:'post'
})

// 现场图片
export const imgUpdataXchang = (uuid)=>request({
    url:'Gatewayinfo/getdata',
    params:{
        uuid,

    }
})


//系统权限信息查询

export const getdataListName = ()=>request({
    url:'Auth/getdata',
    params:{},
    method:'post',
})

// 系统权限更新
export const Authupdatedata =  (data)=>request({
    url:'Auth/updatedata',
    params:data,
    method:'post'
})


// 网关参数uuid
export const  getdataCs= (gateway_uuid,pagenum,pagesize)=>request({
    url:'Property/getdata',
    params:{gateway_uuid,pagenum,pagesize},
    method:'post'
})

// w网关参数跟新

export const  PropertyData= (data)=>request({
    url:'Property/updatedata',
    params:data,
    method:'post'
})

// 实时数据
export const AlistShi = (uuid)=>request({
    url:'Gatewayinfo/getdata',
    method:'post',
    params:{
        uuid
    }
})

export const   getdataCnhannel = ( gateway_uuid,channelid,dateset,enddate,begindate)=>request({
    url:'Gatewaydata/getdata_channel',
    params:{
        gateway_uuid,
        channelid,
        dateset,
        enddate,
        begindate,
       
    },
    method:'post'
})
//1.24网关实时数据(查询某客户默认区域或某区域下网关最新数据)
export const getdataAreaH= (areaflag,customer_uuid,pagesize,pagenum)=>request({
    url:'Gatewaydata/getdata_area',
    params:{areaflag,customer_uuid,pagesize,pagenum},
    method:'post'
})

export const getdataAreaHtse= (customer_uuid,areaflag)=>request({
    url:'Gatewaydata/getdata_area',
    params:{customer_uuid,areaflag},
    method:'post'
})

// 下拉列表的下拉框
export const getdataAreaSelect= (area_uuid)=>request({
    url:'Gatewaydata/getdata_area',
    params:{area_uuid},
    method:'post'
})
//默认展开第一个
export const dataInfoName = ()=>request({
    url:'Gatewaydata/getdata_index',
    params:{},
    method:'post'
}) 


// 系统日志
export const  getdataXt = (pagenum, pagesize,begindate,enddate,businessname)=>request({
    url:'Systemuserlog/getdata',
    params:{pagenum, pagesize,begindate,enddate,businessname},
    method:'post'
})

// 系统回显设置查询
export const  getInfoDataListNmae = ()=>request({
    url:'Systemset/getinfo',
    params:{},
    method:'post'
})
// 系统设置 保存
export const setinfoData  =  (data)=>request({
    url:'Systemset/setinfo',
    params:data,
    method:'post'
})


// 1.23网关数据查询(查询某客户默认区域或某区域下网关最新数据)
export const checcenDN = ()=>request({
    url:'Gatewaydata/getdata_area',
    params:{},
    method:'post'
})


// 地图标点
export const  getdatamapPost= ()=>request({
    url:'Gatewaydata/getdata_map',
    params:{},
    method:'post'
})



//默认打开经销商树

export const getdataIsndex= (pagenum,pagesize)=>request({
    url:'Dealerinfo/getdata_index',
    params:{
        // dealer_uuid,
        pagenum,
        pagesize
    },
    method:'post'
})

// 1.9默认打开客户信息

export const  getdatandexTab= (pagenum,pagesize)=>request({
    url:'Customerinfo/getdata_index',
    params:{
        pagenum,
        pagesize
    },
    method:'post'
})
// 区域默认打开
export const AreainfoTav= (pagenum,pagesize)=>request({
    url:'Areainfo/getdata_index',
    params:{
        pagenum,
        pagesize
    },
    method:'post'
})

// 1.16默认打开网关信息
export const GatewayinfoTab  = (pagenum,pagesize)=>request({
    url:'Gatewayinfo/getdata_index',
    params:{
        pagenum,
        pagesize
    },
    method:'post'
})

// Channelinfo /getdata_index
export const ChannelinfoTab = (pagenum,pagesize)=>request({
    url:'Channelinfo/getdata_index',
    params:{
        pagenum,
        pagesize
    },
    method:'post'
})

//导出ex
export const getdataexportData= (begindate,enddate,dateset,gateway_uuid)=>request({
    url:'Gatewaydata/getdata_export',
    params:{begindate,enddate,dateset,gateway_uuid},
    method:'post'
})


// 图片信息上传公用
export const autoUpload = (formData)=>request({
    url:'Dealerinfo/upload_img',
    data:formData,
    method:'post',
})


export const hunHeData = (gateway_uuid)=>request({
    url:'Propertyandchannel/getdata',
    params:{
        gateway_uuid
    },
    method:'post'
})




// 网关参数 通道数
export const dataTongDao = (gateway_uuid,)=>request({
    url:'Propertyandchannel/getdata',
    params:{
        gateway_uuid
    },
    method:'post'
})


// 设置网关参数
export const SheZhiData = (datatype,gateway_uuid)=>request({
    url:'Gatewayinfo/postgatewayparam',
    params:{datatype,gateway_uuid},
    method:'post'

})


// 重置密码
export const ChongZhiPross = (uuid)=>request({
    url:'Userinfo/resetpassword',
    params:{
        uuid
    },
    method:'post'
})








// 翻译
export const lang_fend = (data)=>request({
    url:'Index/trans_page',
    params:data,
    method:'post'
})

//1.17省市区经销商、客户、区域、网关树形图
export const treeinfo= (levelid,search)=>request({
    url:'Dealerinfo/treeinfo',
    params:{
        levelid,
        search
    },
    method:'post'
})


export const treeinfoLend= (levelid,areaflag)=>request({
    url:'Dealerinfo/treeinfo',
    params:{
        levelid,
        areaflag
    },
    method:'post'
})
//修改密码
export const Updatepassword = (data)=>request({
    url:'Userinfo/Updatepassword',
    params:data,
    method:'post'
})


//友情链接
export const youqingRend = (data,flag)=>request({
    url:'Weblinks/setinfo',
    params:{
        linksinfo:data,
        flag:flag
    },
    method:'post'
})
// 更新
export const updetaHx = ()=>request({
    url:'Weblinks/getinfo',
    params:{},
    method:'post'

})
//修改上限实时数据
export const updataShang = (data)=>request({
    url:'Channelinfo/setchannelname',
    params:data,
    method:'post'
})

//app版本信息获取
export const appDataUpdata = (data)=>request({
    url:'Versioninfo/getdata',
    params:data,
    method:'post'
})
// 发布app版本
export const releaseReq = (data)=>request({
    url:'Versioninfo/updatedata',
    params:data,
    method:'post'
})

// 获取地图信息
export const mapListData = (data)=>request({
    url:'Gatewaydata/getdata_mapinfo',
    params:data,
    method:'post'
})






// 获取日期
export const newDataLine = (monitor_uuid,monthinfo,flag)=>request({
    url:'Monitordata/get_monthdata',
    params:{
        monitor_uuid,
        monthinfo,
        flag
    },
    method:'post',
})

// 抓拍图片

export const zhua_paiData = (data)=>request({
    url:'Monitordata/getdata',
    params:data,
    method:'post'
})


// 录像回放
export const huiFeang_Ht = (dateinfo,pagenum,pagesize,monitor_uuid)=>request({
    url:'Monitordata/get_videodata',
    params:{
        dateinfo,
        pagenum,
        pagesize,
        monitor_uuid,
    },
    method:'post'
})


// ---------------------------------------------------------------------------2.02期-----------------------------
// 1.85更新控制板信息
export const KongZhiList = (data)=>request({
    url:'Controlpanel/getdata',
    params:data,
    method:'post'
})











// // 地图解析
// export const mapJsonData = ()=>request({
//     url:`https://restapi.amap.com/v3/geocode/regeo?output=xml&location=116.310003,39.991957&key=34bb3c713e9d2cbd7141d68cde593a57&radius=1000&extensions=all`,
//     params:{}  
// })